import { ScheduleListState } from './scheduleListSlice';
import { ActiveFilters, FilterValue } from './types';

// Function takes the filter type and the state and returns the selected filters object without the filterType.
export const getSelectedFiltersOtherThan = (
  filterType: string,
  state: ScheduleListState
) => {
  const raw = state.selectedFilters;
  return Object.keys(state.selectedFilters)
    .filter(k => k !== filterType)
    .reduce((obj, key) => {
      obj[key as keyof ActiveFilters] = raw[key as keyof ActiveFilters];
      return obj;
    }, {} as Partial<ActiveFilters>);
};

export const sortByOccurences = (a: FilterValue, b: FilterValue) => {
  if (a.occurences) {
    if (b.occurences) {
      return a.occurences > b.occurences ? -1 : 0;
    }
    return -1;
  }
  return b.occurences ? 1 : 0;
};
